import React from 'react';
import { motion } from 'framer-motion';
import { FiStar, FiExternalLink } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../i18n/LanguageContext';

const Reviews = () => {
  const { t, language } = useLanguage();

  const googleMapsUrl =
    'https://www.google.com/maps/place/The+Lash+Room+-+Studio+de+Beaut%C3%A9/@45.4860965,-73.8680522,17z/data=!4m15!1m8!3m7!1s0x4cc93b08ba2eb2af:0x7a8b91866aaaac73!2s79+Rue+Saint-Antoine,+Montr%C3%A9al,+QC+H9H+2P6!3b1!8m2!3d45.4860965!4d-73.8680522!16s%2Fg%2F11x11hrjkp!3m5!1s0x4cc93bf87f2a25c7:0x128b4abe3968f0ac!8m2!3d45.4860965!4d-73.8680522!16s%2Fg%2F11x900mjc3?entry=ttu&g_ep=EgoyMDI2MDQxNS4wIKXMDSoASAFQAw%3D%3D';

  const reviews = [
    {
      name: 'Jennifer',
      time: language === 'fr' ? 'il y a 3 mois' : '3 months ago',
      text: 'After an 11-day cruise with ocean winds, snorkeling, and ugly crying… my lashes were still flawless. Luxury lashes that do not budge.',
    },
    {
      name: 'Sophia Corilis',
      time: language === 'fr' ? 'il y a 6 mois' : '6 months ago',
      text: "Faye has been my go-to lash girl for as long as I can remember. Perfect every time — classic, hybrid, volume, and even colour.",
    },
    {
      name: 'Brenda Laredo',
      time: language === 'fr' ? 'il y a 5 mois' : '5 months ago',
      text: 'Within five minutes, Faye understood what I needed and knew exactly how to enhance my eye shape — flawless results.',
    },
    {
      name: 'Anastasia Alefantis',
      time: language === 'fr' ? 'il y a 7 mois' : '7 months ago',
      text: 'My first time getting lashes and she made me feel so comfortable. She knew exactly what would suit me as a first-timer.',
    },
    {
      name: 'Sabine Madendjian',
      time: language === 'fr' ? 'il y a 11 mois' : '11 months ago',
      text: 'My lash retention has never been so good. Clean, friendly, fast and gentle — full volume refill in under an hour.',
    },
    {
      name: 'Jenna',
      time: language === 'fr' ? 'il y a 9 mois' : '9 months ago',
      text: 'Professional, quick but meticulous, and explains everything before starting. The lashes are soft, light, and never clump.',
    },
    {
      name: 'Jessica Cohen',
      time: language === 'fr' ? 'il y a un an' : 'a year ago',
      text: 'First time (lash lift) and I loved the results. Very comfortable experience and everything was explained step-by-step.',
    },
    {
      name: 'Eveline Lemire',
      time: language === 'fr' ? 'il y a 3 semaines' : '3 weeks ago',
      text: 'The most hardworking, professional, and passionate — I’ve loved every set and lash lift I’ve done with her.',
    },
  ];

  return (
    <section id="reviews" className="py-24 bg-brand-cream">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-brand-dark mb-4">{t('reviews.title')}</h2>
            <p className="text-brand-muted font-light">
              {t('reviews.subtitle')}
            </p>
          </div>
          <a
            href={googleMapsUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-brand-taupe hover:bg-brand-taupeDark text-white px-6 py-3 rounded-full text-sm font-medium transition-colors shadow-sm w-full md:w-auto"
            aria-label={t('reviews.cta')}
          >
            <span>{t('reviews.cta')}</span>
            <SafeIcon icon={FiExternalLink} className="w-4 h-4" />
          </a>
        </div>

        <div className="w-full overflow-hidden">
          <div className="flex overflow-x-auto hide-scrollbar snap-x snap-mandatory gap-6 pb-2 md:grid md:grid-cols-4 md:gap-4 md:overflow-visible">
            {reviews.map((review, index) => (
              <motion.article
                key={`${review.name}-${index}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                className="flex-none w-[86vw] sm:w-[60vw] md:w-auto snap-center bg-white rounded-2xl p-6 shadow-soft border border-brand-sand"
              >
                <div className="flex items-center justify-between gap-4 mb-3">
                  <div>
                    <p className="font-medium text-brand-dark leading-tight">{review.name}</p>
                    <p className="text-xs text-brand-muted font-light">{review.time}</p>
                  </div>
                </div>
                <p className="text-brand-muted font-light leading-relaxed">“{review.text}”</p>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
